import React from "react";
import PropTypes from "prop-types";
import { TextField, FormControlLabel, Switch, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const ShortAnswerQuestion = ({ question, updateQuestion, canEdit }) => {
  const { t } = useTranslation();

  if (!canEdit) {
    return (
      <Box sx={{ width: "100%" }}>
        <Typography variant="subtitle1" fontWeight={500} sx={{ mb: 1 }}>
          {question.questionText || t("admin.formCreation.untitledQuestion")}
          {question.isRequired && (
            <Typography component="span" color="error" sx={{ ml: 0.5 }}>
              *
            </Typography>
          )}
        </Typography>
        <TextField
          disabled
          fullWidth
          variant="standard"
          placeholder={t("admin.formCreation.short") || "Short answer text"}
          sx={{ pointerEvents: "none" }}
        />
      </Box>
    );
  }

  return (
    <>
      <TextField
        fullWidth
        label={t("admin.formCreation.short")}
        value={question.questionText}
        onChange={(e) => updateQuestion({ ...question, questionText: e.target.value })}
        sx={{ mb: 2 }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={question.isRequired}
            onChange={(e) => updateQuestion({ ...question, isRequired: e.target.checked })}
          />
        }
        label={t("admin.formCreation.required")}
      />
    </>
  );
};

ShortAnswerQuestion.propTypes = {
  question: PropTypes.shape({
    formId: PropTypes.number,
    questionText: PropTypes.string,
    fieldType: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    options: PropTypes.string,
    orderIndex: PropTypes.number,
  }).isRequired,
  updateQuestion: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default ShortAnswerQuestion;
